import { Modal, ModalProps } from "react-bootstrap";
import { useEffect } from "react";
import Check from "../compoment/icon/Check";

import Alert from './../assets/img/alert-icon 1.png'

interface PrintSizeModalProps extends ModalProps {
  onHide: () => void;
}

const PrintSizeModal = (props: PrintSizeModalProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      props.onHide();
    }, 3000); // 3 seconds

    return () => clearTimeout(timer); // cleanup on unmount
  }, [props.onHide]);
  return (
    <Modal
      {...props}
      backdrop="static"
      className={`favoriteModal`}
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div>
          <div>
            <img src={Alert} alt="" />
          </div>
          <div className="header">
            Please select one or more print sizes
          </div>
          <div className="d-flex align-items-center justify-content-center gap-3"></div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PrintSizeModal;
